import React, {useState, useEffect} from 'react';
import SMCModal from '../../components/core/SMCModal';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody'
import {useTranslation} from 'react-i18next';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCLabel from '../../components/Simple/SMCLabel';
import SMCTextInput from '../../components/Simple/SMCTextInput';
import {SMCSelect, SMCOption} from '../../components/Simple/SMCSelect';
import SMCButton from '../../components/Simple/SMCButton';
import {GatewayGetSchema} from '../../api/DBSchema/Gateway';
import {validateIpAddress, validateSubnetMask} from '../../utils/utils';
import {useSMCSnackbar} from '../../utils/hooks';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const adminAccessSchema = GatewayGetSchema.pages.administratorAccess.adminAccessDataListSchema;

const typeValues = {
    ipAddress: adminAccessSchema.typeValues.ipAddress,
    network: adminAccessSchema.typeValues.network
}

function AdminAccessEditorModal({
    isOpen = false,
    width = 610,
    height = 480,
    onCancel,
    onSuccess,
    defaultObject
}) {
    const { t } = useTranslation();
    const { enqueueErrorSnackbar } = useSMCSnackbar();

    const [type, setType] = useState(typeValues.ipAddress);
    const [ipAddress, setIpAddress] = useState('');
    const [subnetMask, setSubnetMask] = useState('');

    const onFinish = () => {
        // Validate
        if (!validateIpAddress(ipAddress)) {
            enqueueErrorSnackbar(t('com.sofaware.schema.ATTRIBUTE_INVALID_VALUE_IP', [ipAddress, t('SMP.PLAN.ADMIN_ACCESS_WIZ.IP_ADDRESS')]), {
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'bottom'
                }
            });
            return;
        }
        if (type === typeValues.network && !validateSubnetMask(subnetMask)) {
            enqueueErrorSnackbar(t('com.sofaware.schema.ATTRIBUTE_INVALID_VALUE_SUBNET_MASK', [subnetMask]), {
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'bottom'
                }
            });
            return;
        }

        const retVal = {
            [adminAccessSchema.type]: type,
            [adminAccessSchema.ipAddr]: ipAddress,
            [adminAccessSchema.subnetMask]: (type === typeValues.network) ? subnetMask : null
        };
        onSuccess(retVal);
    }

    // On each new open, reset values
    useEffect(() => {
        if (isOpen) {
            // Set default values
            setType(typeValues.ipAddress);
            setIpAddress('');
            setSubnetMask('');

            // If default object exists, use its values
            if (defaultObject) {
                defaultObject.type && setType(defaultObject.type);
                defaultObject.ipAddr && setIpAddress(defaultObject.ipAddr);
                defaultObject.subnetMask && setSubnetMask(defaultObject.subnetMask);
            }
        }
    }, [isOpen, defaultObject]);

    return (
        <SMCModal
            isOpen={isOpen}
            width={width}
            height={height}
            title={t('SMP.PLAN.ADMIN_ACCESS_WIZ.ADMIN_ACCESS')}
            onRequestClose={onCancel}
        >
            <SMCModalBody>
                <SMCLabel bold>{t('SMP.PLAN.ADMIN_ACCESS_WIZ.ACCESS_IP_ADDRESS_CONF')}</SMCLabel>
                <SMCSelect
                    value={type}
                    onChange={e => setType(e.target.value)}
                    label={t('SMP.PLAN.ADMIN_ACCESS_WIZ.SOURCE_TYPE')}
                >
                    <SMCOption value={typeValues.ipAddress}>{t('SMP.PLAN.ADMIN_ACCESS_WIZ.IP_ADDRESS')}</SMCOption>
                    <SMCOption value={typeValues.network}>{t('SMP.NETWORK')}</SMCOption>
                </SMCSelect>
                <SMCTextInput
                    value={ipAddress}
                    onChange={e => setIpAddress(e.target.value)}
                    label={t('SMP.PLAN.ADMIN_ACCESS_WIZ.IP_ADDRESS')}
                />
                {
                    type === typeValues.network && (
                        <SMCTextInput
                            value={subnetMask}
                            onChange={e => setSubnetMask(e.target.value)}
                            label={t('SMP.PLAN.ADMIN_ACCESS_WIZ.SUBNET_MASK')}
                        />
                    )
                }
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={onFinish}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_FINISH')}
                </SMCButton>
                <SMCButton onClick={onCancel}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </SMCModal>

    );
}

export default AdminAccessEditorModal;